import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Producto" },
  { label: "Modelos", icon: "fas fa-tshirt", color: "#10b981", bg: "#f0fdf4", href: "/ListadoArticulos", desc: "Alta y edición de artículos", perm: "menu_articulos" },
  { type: "section", label: "Clasificación" },
  { label: "Lineas", icon: "fas fa-bars", color: "#3b82f6", bg: "#eff6ff", href: "/Lineas", desc: "Catálogo de líneas", perm: "menu_articulos" },
  { label: "Marcas", icon: "far fa-copyright", color: "#f59e0b", bg: "#fffbeb", href: "/Marcas", desc: "Catálogo de marcas", perm: "menu_articulos" },
  { label: "Departamentos", icon: "fas fa-users", color: "#8b5cf6", bg: "#f5f3ff", href: "/Familias", desc: "Catálogo de departamentos", perm: "menu_articulos" },
  { label: "Colecciones", icon: "fas fa-calendar-alt", color: "#0ea5e9", bg: "#f0f9ff", href: "/Colecciones", desc: "Catálogo de colecciones", perm: "menu_articulos" },
  { label: "Composiciones", icon: "fas fa-percent", color: "#f43f5e", bg: "#fff1f2", href: "/Composiciones", desc: "Catálogo de composiciones", perm: "menu_articulos" },
  { type: "section", label: "Atributos" },
  { label: "Colores", icon: "fas fa-palette", color: "#14b8a6", bg: "#f0fdfa", href: "/Colores", desc: "Catálogo de colores", perm: "menu_articulos" },
  { label: "Tallas", icon: "fas fa-ruler", color: "#6366f1", bg: "#eef2ff", href: "/Tallas", desc: "Catálogo de tallas", perm: "menu_articulos" },
];

function BotonesArticulos() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-box" color="#3b82f6" bg="#eff6ff" title="Artículos" subtitle="Catálogo de producto y sus clasificaciones" />
        {user.menu_articulos ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesArticulos;
